import { render, staticRenderFns } from "./BundlePaymentDistribution.vue?vue&type=template&id=96dc5be8&scoped=true"
import script from "./BundlePaymentDistribution.vue?vue&type=script&lang=js"
export * from "./BundlePaymentDistribution.vue?vue&type=script&lang=js"
import style0 from "./BundlePaymentDistribution.vue?vue&type=style&index=0&id=96dc5be8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96dc5be8",
  null
  
)

export default component.exports